<template>
  <div class="component-content configuration-personal-title">
    <div class="component-content-scroll">
      <div class="component-content-title">Configure your personal title</div>
      <ul>
        <li
          class="xs-text uppercase"
          :class="{
            active:
              'title-font' == this.subSteps[this.currentSubStep].activeItem,
          }"
          v-on:click="goToTitleFont"
        >
          Font selection
        </li>
        <li
          :class="{
            active:
              'title-text' == this.subSteps[this.currentSubStep].activeItem,
          }"
          class="xs-text uppercase"
          v-on:click="goToTitleText"
        >
          Enter text
        </li>
      </ul>
      <component
        v-bind:is="getContent"
        :results="results"
        :components="components"
        v-on:update-title-font="updateTitleFont"
        v-on:update-title-text="updateTitleText"
      ></component>
    </div>
    <div class="buttonset">
      <button class="btn btn-outline-dark back-button" v-on:click="goBack">
        back
      </button>
      <finish-configuration-button
        v-if="canFinishConfiguration()"
        v-on:finish-configuration="finishConfiguration"
       ></finish-configuration-button>
      <button class="btn btn-outline-dark next-button" v-on:click="goNext">
        next
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import frameTitleFont from "./sub-components/frame-title-font.vue";
import frameTitleText from "./sub-components/frame-title-text.vue";
import FinishConfigurationButton from './finish-configuration-button.vue';

Vue.component("frame-title-font", frameTitleFont);
Vue.component("frame-title-text", frameTitleText);
Vue.component("finish-configuration-button", FinishConfigurationButton);

export default {
  name: "configuration-personal-title",
  data() {
    return {
      subSteps: [
        {
          name: "title-font",
          template: "frame-title-font",
          activeItem: "title-font",
        },
        {
          name: "title-text",
          template: "frame-title-text",
          activeItem: "title-text",
        },
      ],
      currentSubStep: 0,
    };
  },
  computed: {
    getContent: function () {
      return this.subSteps[this.currentSubStep].template;
    },
  },
  props: ["bike", "configuratorSteps", "currentStep", "results", "components"],
  methods: {
    goNext: function () {
      if (this.currentSubStep==0 && this.results.frame.title.family==null) {
        this.$emit("go-next");
        return;
      }
      if (this.currentSubStep==1 && this.results.frame.title.text==null) {
        this.$emit('set-error', 'Enter some text');
        return false;
      }
      if (this.currentSubStep < this.subSteps.length - 1) {
        this.currentSubStep++;
      } else {
        this.$emit("go-next");
      }
    },
    goBack: function () {
      if (this.currentSubStep > 0) {
        this.currentSubStep--;
      } else {
        this.$emit("go-back");
      }
    },
    goToTitleFont: function () {
      this.currentSubStep = 0;
    },
    goToTitleText: function () {
      this.currentSubStep = 1;
    },
    updateTitleFont: function (e) {
      this.$emit("update-title-font", e);
    },
    updateTitleText: function (e) {
      this.$emit("update-title-text", e);
    },
    canFinishConfiguration: function() {
// if fork is present, we need to check if the fork is selected and has a colour
        if (this.components.fork?.length > 0) 
        {
          return (
          this.results.frame !== null &&
          this.results.frame !== undefined &&
          this.results.colour !== null &&
          this.results.colour !== undefined &&
          this.results.fork !== null &&
          this.results.fork !== undefined
          );
        }
        else
        {
          // no fork, so we can finish configuration
          return (
            this.results.frame !== null &&
            this.results.frame !== undefined &&
            this.results.colour !== null &&
            this.results.colour !== undefined
          );
        }
    },
    finishConfiguration: function() {
        this.$emit("finish-configuration");
    }
  },
};
</script>

<style lang="scss" scoped>
.configuration-personal-title {
  ul {
    list-style: none;
    padding: 0;
    margin-top: 20px;
    li {
      display: inline-block;
      margin-right: 25px;
      text-transform: uppercase;
      color: #888;
      cursor: pointer;
      &.active {
        position: relative;
        color: black;
        &::after {
          content: "";
          width: 100%;
          border-bottom: 1px solid black;
          position: absolute;
          left: 0;
          bottom: -4px;
        }
      }
    }
  }
}
</style>
